import { ReactElement, ReactNode } from 'react';
import { AnalyticsContext, AnalyticsContextValue } from './AnalyticsContext';
import { TrackingEvent } from '../events/tracking-events';

export type AnalyticsProviderProps = {
    children: ReactNode;
};

export const AnalyticsProvider = (props: AnalyticsProviderProps): ReactElement => {
    const { children } = props;

    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const authContextValue: AnalyticsContextValue = {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        sendEvent: (_event: TrackingEvent, _payload: Record<string, unknown> = {}) => {},
    };

    return <AnalyticsContext.Provider value={authContextValue}>{children}</AnalyticsContext.Provider>;
};
